import { useEffect, useState } from "react";
import moment from "moment";
import { t } from "i18next";
import Select, { StylesConfig } from 'react-select';
import { formatDateWithDateAndMonthName, getFilteredList, getPageSizeArray, setItemStatus, sortData, getValueFromResource, FormatInvoiceDecimalNumber } from '../../../../common/timeLiveFunction';
import { getTimeFromDecimal } from '../../../../common/timesheetFunction';
import CustomPagination from "../../../../common/Pagination";
import clsx from "clsx";
import { Dropdown } from 'react-bootstrap';
import Loader from '../../../../common/Loader';
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { getAccountProjectTaskHierarchyForEmployeeDetail, checkedAllState, unCheckedAllState, checkedState, unCheckedState } from "../EmployeeTaskSlice";
import PageSizeSelect from "../../../../common/PageSizeSelect";

const initialSortValues = {
  sortOrder: 'asc',
  sortColumn: 'TaskName'
}

const EmployeeTaskList = (props: any) => {
  const { AccountEmployeeId } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { employeeTaskList, isLoading, isReload, timeEntryFormat } = useAppSelector((state) => state.employeeTask);
     const { cultureInfoName, decimalPlaces, decimalFormat } = useAppSelector((state) => state.globalState);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [clientSideSorting, setClientSideSorting] = useState<any | ''>(initialSortValues);
  // const [hoveredColumn, setHoveredColumn] = useState(null);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  }

  const handleSearch = (event: any) => {
    const { value } = event.target;
    setSearchTerm(value);
    setCurrentPage(1);
  }

  const handlePageSizeChange = (selectedOption: any) => {
    const { value, label } = selectedOption;
    setPageSize(Number(value));
    setCurrentPage(1);
  }

  const filteredData = getFilteredList(employeeTaskList, searchTerm);
  const indexOfLastItem = currentPage * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;
  // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const currentItems = sortData(filteredData, clientSideSorting.sortOrder, clientSideSorting.sortColumn).slice(indexOfFirstItem, indexOfLastItem);
  const totalItems = employeeTaskList.length;
  const recordsFiltered = filteredData.length;

  useEffect(() => {
    dispatch(getAccountProjectTaskHierarchyForEmployeeDetail(AccountEmployeeId));
  }, [isReload]);

  const navigateToAccountProjectTaskSummary = (obj: any) => {
    localStorage.setItem('objTask', JSON.stringify(obj));
    navigate(`/accountprojecttasksummary/${obj.AccountProjectId}/${obj.AccountProjectTaskId}`);
    // navigate('/accountprojecttasksummary', { state: { obj } });
  }

  // const determineDueStatus = (deadline: any, startDate: any) => {
  //   const now = new Date();
  //   let status: string = "Soon Due"
  //   if (deadline) {
  //     const deadlineDate = new Date(deadline);
  //     if (now > deadlineDate) {
  //       status = 'Overdue';
  //     } else if (now.getDate() === deadlineDate.getDate()) {
  //       status = 'Due';
  //     } else if (now < deadlineDate) {
  //       status = 'Soon Due';
  //     }
  //   } else if (startDate && now < new Date(startDate)) {
  //     status = 'Start Soon';
  //   }
  //   return status;
  // }

  const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
    setClientSideSorting({
      ...clientSideSorting,
      sortOrder: sortOrder,
      sortColumn: sortColumn
    });
    // setPageSize(10);
    setPageSize(pageSize);
    setCurrentPage(1);
  }

  // const handleMouseEnter = (columnIndex: any) => {
  //   setHoveredColumn(columnIndex);
  // }

  // const handleMouseLeave = () => {
  //   setHoveredColumn(null);
  // }

  return (
    <>
      {isLoading && <Loader />}
      <div className="card card-custom admin-card">
        <div className="card-header card-drop sticky-top bg-white">
          <h3 className="card-title fw-bold headerTitle">
            {/* {t('Task List')} */}
            {getValueFromResource('Task List',dispatch, t)}
            </h3>
          <div className="card-toolbar align-items-center">
            <div className="position-relative">
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearch}
                placeholder=
                // {t('Search')}
                {getValueFromResource('Search',dispatch, t)}
                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                data-kt-user-table-filter="search"
              />
              <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                <span className="path1"></span>
                <span className="path2"></span>
              </i>
            </div>
            <div className='h-35px w-1px mx-1'></div>
            <div className="d-flex align-items-center">
              {/* <Select
                styles={colourStyles}
                options={getPageSizeArray()}
                value={getPageSizeArray().find((option: any) => option.value == pageSize)}
                onChange={handlePageSizeChange}
                className='fs-7 fw-normal'
              /> */}
              <PageSizeSelect onChange={handlePageSizeChange} />
            </div>
            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
            <div>
              {(currentItems.length > 0) ? (
                <CustomPagination
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                  pageSize={pageSize}
                  totalItems={totalItems}
                  start={(currentPage - 1) * pageSize}
                  t={t}
                >
                </CustomPagination>
              ) : null}
            </div>
          </div>
        </div>
        {/* <div className='card-body py-3'> */}
        <div className="card-Report-body py-3">
          <div className='table-responsive'>
            <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
              <thead>
                <tr className='thHeading align-middle'>
                  <th className='w-25px'
                  // onMouseEnter={() => handleMouseEnter(0)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {clientSideSorting.sortColumn === 'IsDisabled' ?
                      clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 0 && 
                      <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th className='w-25px'
                  // onMouseEnter={() => handleMouseEnter(1)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {clientSideSorting.sortColumn === 'deadlineStatus' ?
                      clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "deadlineStatus") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "deadlineStatus") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 1 && 
                      <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "deadlineStatus") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "deadlineStatus") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th style={{ width: '40%' }}
                  // onMouseEnter={() => handleMouseEnter(2)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Task Name")} */}
                    {getValueFromResource('Task Name',dispatch, t)}
                    {clientSideSorting.sortColumn === 'TaskName' ?
                      clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "TaskName") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "TaskName") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 2 && 
                      <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "TaskName") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "TaskName") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th style={{ width: '15%' }}
                  // onMouseEnter={() => handleMouseEnter(3)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Progress")} */}
                    {getValueFromResource('Progress',dispatch, t)}
                    {clientSideSorting.sortColumn === 'CompletedPercent' ?
                      clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "CompletedPercent") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "CompletedPercent") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 3 && 
                      <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "CompletedPercent") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "CompletedPercent") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th className='min-w-10px'>{t("")}</th>
                  <th style={{ width: '15%' }}
                  // onMouseEnter={() => handleMouseEnter(4)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Date")} */}
                    {getValueFromResource('Date',dispatch, t)}
                    {clientSideSorting.sortColumn === 'DeadlineDate' ?
                      clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "DeadlineDate") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "DeadlineDate") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 4 && 
                      <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "DeadlineDate") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "DeadlineDate") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th style={{ width: '15%' }}
                  // onMouseEnter={() => handleMouseEnter(5)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Status")} */}
                    {getValueFromResource('Status',dispatch, t)}
                    {clientSideSorting.sortColumn === 'TaskStatus' ?
                      clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "TaskStatus") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "TaskStatus") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 5 && 
                      <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "TaskStatus") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "TaskStatus") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th style={{ width: '15%' }}
                  // onMouseEnter={() => handleMouseEnter(6)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Hours")} */}
                    {getValueFromResource('Hours',dispatch, t)}
                    {clientSideSorting.sortColumn === 'TotalHours' ?
                      clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "TotalHours") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "TotalHours") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 6 && 
                      <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "TotalHours") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "TotalHours") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 && currentItems.map((item: any) => {
                  return (
                    <tr key={item.AccountProjectTaskId}>
                      <td>
                        <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.IsDisabled === "No" ? "Active" : "InActive"))}>
                          {item.IsDisabled === "No" ? "Active" : "InActive"}
                        </span>
                      </td>
                      <td>
                        {/* <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(determineDueStatus(item.DeadlineDate, item.StartDate)))}>
                          {determineDueStatus(item.DeadlineDate, item.StartDate)}
                        </span> */}
                        <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.deadlineStatus))}>
                          {item.deadlineStatus}
                        </span>
                      </td>
                      <td>
                        <a className='text-dark fw-bold d-block cursor'
                          onClick={() => {
                            navigateToAccountProjectTaskSummary({
                              "AccountProjectId": item.AccountProjectId,
                              "AccountProjectTaskId": item.AccountProjectTaskId,
                              "ProjectCode": item.ProjectCode,
                              "ProjectName": item.ProjectName,
                              "Status": item.Status,
                              "StartDate": item.StartDate,
                              "Deadline": item.Deadline,
                              "ProjectBillingRateTypeId": 0
                            });
                          }}
                        >
                          {item.TaskName}
                        </a>
                        <span style={{ color: '#7b8ba6', fontSize: 11 }}>
                          {/* {`Priority, ${item.Priority}`} */}
                          {getValueFromResource(`Priority, ${item.Priority}`, dispatch, t)}
                          </span>
                      </td>
                      <td className='text-center'>
                        <div className='d-flex flex-column w-100 me-2'>
                          <div className='d-flex flex-stack mb-2'>
                            <span className='text-muted me-2 fs-7 fw-semibold'>{`${FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.CompletedPercent, 2)}%`}</span>
                          </div>
                          <div className='progress h-6px w-100'>
                            <div
                              className='progress-bar bg-success'
                              role='progressbar'
                              style={{ width: `${item.CompletedPercent}%` }}
                            ></div>
                          </div>
                        </div>
                      </td>
                      <td></td>
                      <td>
                        <a className='text-dark fw-bold d-block'>
                          <i className="ki-outline ki-calendar-2 fs-5 text-dark"></i> 
                          {formatDateWithDateAndMonthName(item.DeadlineDate, cultureInfoName.toString())}
                          {/* {`${moment.parseZone(item.DeadlineDate).format('DD MMM yy')}`} */}
                        </a>
                        <span style={{ color: '#7b8ba6', fontSize: 11 }}>
                          {/* {`Deadline Date`} */}
                          {getValueFromResource('Deadline Date',dispatch, t)}
                        </span>
                      </td>
                      <td>
                        <span className={`badge fs-7 ${setItemStatus(item.TaskStatus)}`}>{item.TaskStatus}</span>
                      </td>
                      <td>
                        <a className='text-gray-800 d-block'>
                          {decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.CompletedPercent, 2) : getTimeFromDecimal(item.TotalHours, false)}
                        </a>
                      </td>
                      <td className='text-center'>
                        <Dropdown
                          style={{ marginLeft: 1 }}
                          className={clsx('cursor-pointer symbol')}
                          data-kt-menu-attach='parent'
                          data-kt-menu-placement='bottom-end'
                        >
                          <Dropdown.Toggle
                            variant="transparent"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t("More")}
                            {getValueFromResource('More',dispatch, t)}
                            data-tooltip-place="top"
                          >
                            <i className="bi bi-three-dots fs-7"></i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                            <div className='menu-hover-bg-sec'>
                              <Dropdown.Item
                                className="menu-item me-lg-0"
                                onClick={() => {
                                  navigateToAccountProjectTaskSummary({
                                    "AccountProjectId": item.AccountProjectId,
                                    "AccountProjectTaskId": item.AccountProjectTaskId,
                                    "ProjectCode": item.ProjectCode,
                                    "ProjectName": item.ProjectName,
                                    "Status": item.Status,
                                    "StartDate": item.StartDate,
                                    "Deadline": item.Deadline,
                                    "ProjectBillingRateTypeId": 0
                                  });
                                }}
                              >
                                <span className="menu-icon custom-menu mb-2">
                                  <i className="bi bi-file-earmark-text fs-4 iconColor">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                  </i>
                                </span>
                                <span className="menu-title custom-menu-fontsize">
                                  {/* {`${t('View Task')}`} */}
                                  {getValueFromResource('View Task',dispatch, t)}
                                  </span>
                              </Dropdown.Item>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            {employeeTaskList.length === 0 &&
              <div className=''>
                <p className='noDataFound'>
                  {/* {t('No Record Found')} */}
                  {getValueFromResource('No Record Found',dispatch, t)}
                  </p>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default EmployeeTaskList

const colourStyles: StylesConfig = {
  control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}